export default {
  office: {
    lastUpdate: null,
    loading: false,
    data: {
      _request: {},
      grouped: {},
      metadata: {}, // qtd clientes, data ref, pl_total
      total: {},
      labels: [],
    },
  },
  professionals: {
    lastUpdate: null,
    loading: false,
    data: {
      _request: {},
      grouped: {},
      metadata: {},
      total: {},
      labels: [],
    },
  },
  clientsGrouped: {
    lastUpdate: null,
    loading: false,
    data: {
      // 1: {
      //   _request: {},
      //   grouped: {},
      //   metadata: {}, // qtd clientes, data ref, id_profissional, pl_total
      //   total: {},
      // },
    },
  },
  clientsListed: {
    lastUpdate: null,
    loading: false,
    data: {},
  },
}
